import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/3d2cujiq_MAIN%20%283%29.png";
const LOGO_WHITE_URL = "https://customer-assets.emergentagent.com/job_ktm-2026/artifacts/16pa21xt_Full%20Logo%20White.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-ktm-navy text-white" data-testid="footer" role="contentinfo">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <img 
              src={LOGO_WHITE_URL} 
              alt="KTM Construction Logo" 
              className="h-48 w-auto"
              data-testid="footer-logo"
              data-logo="true"
            />
            <p className="text-slate-300 leading-relaxed">
              Building the future of California and Nevada with precision and integrity. 
              Multifamily and commercial construction services you can trust.
            </p>
            <div className="flex gap-4" role="list" aria-label="Social media links">
              <a 
                href="https://www.facebook.com/people/KTM-Construction/61587904562594/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 bg-white/10 flex items-center justify-center hover:bg-ktm-red transition-colors"
                data-testid="footer-facebook"
                aria-label="Visit KTM Construction on Facebook (opens in new tab)"
              >
                <Facebook className="w-5 h-5" aria-hidden="true" />
              </a>
              <a 
                href="#"
                className="w-11 h-11 bg-white/10 flex items-center justify-center hover:bg-ktm-red transition-colors"
                data-testid="footer-instagram"
                aria-label="Visit KTM Construction on Instagram"
              >
                <Instagram className="w-5 h-5" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Footer navigation">
            <h2 className="font-chivo font-bold text-lg mb-6 text-white">Quick Links</h2>
            <ul className="space-y-3" role="list">
              {['Home', 'About', 'Services', 'Gallery', 'Contact'].map((item) => (
                <li key={item}>
                  <Link 
                    to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                    className="text-slate-300 hover:text-ktm-red transition-colors inline-block py-1"
                    data-testid={`footer-link-${item.toLowerCase()}`}
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Services */}
          <div>
            <h2 className="font-chivo font-bold text-lg mb-6 text-white">Services</h2>
            <ul className="space-y-3" role="list">
              {[
                'Multifamily Construction',
                'Commercial Construction',
                'Remodeling',
                'Interior Finishing',
                'Exterior Work'
              ].map((service) => (
                <li key={service}>
                  <Link 
                    to="/services"
                    className="text-slate-300 hover:text-ktm-red transition-colors inline-block py-1"
                    aria-label={`Learn more about ${service}`}
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <address className="not-italic">
            <h2 className="font-chivo font-bold text-lg mb-6 text-white">Contact Us</h2>
            <ul className="space-y-4" role="list">
              <li>
                <a 
                  href="tel:916-872-1882"
                  className="flex items-start gap-3 text-slate-300 hover:text-ktm-red transition-colors py-1"
                  data-testid="footer-phone"
                  aria-label="Call us at 916-872-1882"
                >
                  <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" aria-hidden="true" />
                  <span>916-872-1882</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:ktmconstruction21@gmail.com"
                  className="flex items-start gap-3 text-slate-300 hover:text-ktm-red transition-colors py-1"
                  data-testid="footer-email"
                  aria-label="Email us at ktmconstruction21@gmail.com"
                >
                  <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" aria-hidden="true" />
                  <span>ktmconstruction21@gmail.com</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-slate-300 py-1">
                  <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" aria-hidden="true" />
                  <span>
                    8331 Sierra College Blvd<br />
                    Suite 208<br />
                    Roseville, CA
                  </span>
                </div>
              </li>
            </ul>
          </address>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © {currentYear} KTM Construction. All rights reserved.
          </p>
          <div className="text-slate-400 text-sm text-center md:text-right">
            <p>California License #1045468</p>
            <p>Nevada License #0094188</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
